import React from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

export interface ActivityItemProps {
  activityIcon?: React.ReactNode;
  activityDescription?: React.ReactNode;
  timeStamp?: React.ReactNode;
  comments?: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    color: tokens.colorNeutralForeground2,
    fontSize: '12px',
    fontWeight: 400,
    WebkitFontSmoothing: 'antialiased',
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minWidth: '32px',
    width: '32px',
    height: '32px',
    fontSize: '20px',
    lineHeight: '20px',
    marginTop: '3px',
  },
  content: {
    padding: '0 8px',
  },
  description: {
    display: 'inline',
  },
  comments: {
    color: tokens.colorNeutralForeground1,
  },
  timeStamp: {
    fontSize: '10px',
    fontWeight: 400,
    color: tokens.colorNeutralForeground2,
  },
});

const ActivityItem = ({
  activityIcon,
  activityDescription,
  timeStamp,
  comments,
  className,
}: ActivityItemProps): JSX.Element => {
  const styles = useStyles();

  return (
    <div className={mergeClasses(styles.root, className)}>
      {activityIcon != null && <div className={styles.iconContainer}>{activityIcon}</div>}
      <div className={styles.content}>
        {activityDescription != null && (
          <div className={styles.description}>{activityDescription}</div>
        )}
        {comments != null && <div className={styles.comments}>{comments}</div>}
        {timeStamp != null && <div className={styles.timeStamp}>{timeStamp}</div>}
      </div>
    </div>
  );
};

export default ActivityItem;
